<style lang="less">
</style>
<template>
  <div>
    <Drawer
      :closable="false"
      placement="right"
      v-model="drawerVisible"
      width="60%"
      :title="drawerTitle"
    >
      <Row>
        <Col>
          <Card shadow="false">
            <Row>
              <Form
                ref="form"
                :model="form"
                :label-width="70"
                :rules="formValidate"
                style="position: relative"
              >
                <FormItem label="模块分类" prop="sliderType">
                  <Select
                    v-model="form.sliderType"
                    placeholder="请选模块分类"
                    @on-change="selectJump"
                    clearable
                    style="width: 200px"
                  >
                    <Option :value="1">APP轮播图</Option>
                    <Option :value="2">PC首页轮播图</Option>
                    <Option :value="3">APP启动图</Option>
                    <Option :value="4">PC人才测评</Option>
                    <Option :value="5">PC学分转换</Option>
                    <Option :value="6">PC关于我们</Option>
                    <Option :value="7">PC新闻中心</Option>
                    <Option :value="8">PC帮助中心</Option>
                    <Option :value="9">PC联系我们</Option>
                    <Option :value="10">PC行业学院</Option>
                    <Option :value="11">PC认证考试</Option>
                    <Option :value="12">小程序轮播图</Option>
                  </Select>
                </FormItem>
                <FormItem label="跳转方式" prop="jumpType" v-show="twoShow">
                  <Select
                    v-model="form.jumpType"
                    placeholder="请选择跳转方式"
                    clearable
                    style="width: 200px"
                  >
                    <Option
                      v-for="item in jumpTypeList"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.label }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem label="标题" prop="sliderTitle">
                  <Input v-model="form.sliderTitle" style="width: 600px" />
                </FormItem>
                <FormItem label="封面图" prop="sliderImg">
                  <upload-input
                    :fileUrl="form.sliderImg"
                    fileSize="400"
                    :fileWh="imgSize"
                    @on-change="handleUpload"
                    width="400px"
                    ref="upload"
                  ></upload-input>
                </FormItem>
                <FormItem
                  label="介绍"
                  prop="content"
                  v-show="this.form.jumpType == 3"
                >
                  <div ref="editor"></div>
                </FormItem>
                <FormItem
                  label="链接地址"
                  prop="content"
                  v-show="this.form.jumpType == 1"
                >
                  <Input v-model="form.content" clearable style="width: 600px">
                    <span slot="prepend">http://</span>
                  </Input>
                </FormItem>

                <Form-item label class="br" v-show="this.form.jumpType == 3">
                  <Button @click="editHTML" icon="ios-create-outline"
                    >编辑HTML代码</Button
                  >
                  <Button @click="fullscreenModal = true" icon="md-eye"
                    >预览</Button
                  >
                </Form-item>
                <Form-item class="br">
                  <Button
                    type="primary"
                    :loading="submitLoading"
                    @click="handelSubmit"
                    style="width: 100px"
                    >提交</Button
                  >
                  <Button @click="handelCancel">取消</Button>
                </Form-item>
                <Spin size="large" fix v-if="loading"></Spin>
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- html编辑 -->
      <Modal
        title="编辑html代码"
        v-model="showHTMLModal"
        :mask-closable="false"
        :width="900"
        :fullscreen="full"
      >
        <Input
          v-if="!full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
          style="max-height: 60vh; overflow: auto"
        />
        <Input
          v-if="full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
        />
        <div slot="footer">
          <Button @click="full = !full" icon="md-expand">全屏开/关</Button>
          <Button
            @click="editHTMLOk"
            type="primary"
            icon="md-checkmark-circle-outline"
            >确定保存</Button
          >
        </div>
      </Modal>
      <Modal title="预览" v-model="fullscreenModal" fullscreen>
        <div v-html="form.courseContent">{{ form.courseContent }}</div>
        <div slot="footer">
          <Button @click="fullscreenModal = false">关闭</Button>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>
<script>
import { uploadFile, addSlider, editSlider, getSlider } from "@/api/index";
import uploadInput from "@/views/my-components/flyme/upload-input";
import E from "wangeditor";
// 表情包配置 自定义表情可在该js文件中统一修改
import { sina } from "@/libs/emoji";

let editor = null;
var xss = require("xss");
export default {
  name: "slider-drawer",
  components: {
    uploadInput,
  },
  data() {
    return {
      type: 0,
      loading: false, // 表单加载状态
      selectUsers: [],
      drawerTitle: "添加课程",
      drawerVisible: false,
      twoShow: true,
      imgSize: "750*566",
      form: {
        sliderTitle: "",
        content: "",
        jumpUrl: "",
        sliderImg: "",
        jumpType: 3,
        sliderType: 1,
      },
      jumpTypeList: [],
      oldTwo: [
        {
          value: 3,
          label: "内部H5",
        },
        {
          value: 0,
          label: "无跳转",
        },
        {
          value: 2,
          label: "内部模块",
        },
        {
          value: 1,
          label: "外部跳转",
        },
      ],
      newTwo: [
        {
          value: 0,
          label: "无跳转",
        },
        {
          value: 1,
          label: "外部跳转",
        },
      ],
      formValidate: {
        sliderTitle: [
          { required: true, message: "标题不能为空", trigger: "blur" },
        ],
      },
      submitLoading: false, // 添加或编辑提交状态
      dataEdit: "", // 编辑数据
      showHTMLModal: false, // 显示html
      full: false, // html全屏开关
      fullscreenModal: false, // 显示全屏预览
    };
  },
  methods: {
    init() {
      this.initEditor();
    },
    showDrawer(params) {
      this.jumpTypeList = this.oldTwo;
      this.twoShow = true;
      this.form.jumpType = 3;
      this.imgSize = "750*566";
      if (params.id) {
        this.type = 1;
        this.drawerTitle = "编辑轮播图";
        this.form.id = params.id;
        this.getData();
      } else {
        this.$refs.form.resetFields();
        this.$refs.upload.setPicUrl("");
        this.drawerTitle = "添加轮播图";
        this.type = 0;
      }
      this.drawerVisible = true;
    },
    selectJump() {
      this.jumpTypeList = this.oldTwo;
      this.form.jumpType = 3;
      this.twoShow = true;
      this.imgSize = "750*566";
      if (this.form.sliderType == 2) {
        //pc首页轮播图
        this.jumpTypeList = this.newTwo;
        this.form.jumpType = 0;
        this.imgSize = "1920*425";
      }
      if (
        this.form.sliderType != 1 &&
        this.form.sliderType != 2 &&
        this.form.sliderType != 3
      ) {
        this.form.jumpType = 0;
        this.twoShow = false;
        this.imgSize = "1920*200";
      }
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        this.form.content = html;
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.content;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.content = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    getData() {
      this.loading = true;
      getSlider(this.form.id).then((res) => {
        this.loading = false;
        if (res.status === true) {
          this.form = res.data;
          this.imgSize = "750*566";
          if (
            this.form.sliderType != 1 &&
            this.form.sliderType != 2 &&
            this.form.sliderType != 3
          ) {
            this.form.jumpType = 0;
            this.twoShow = false;
            this.imgSize = "1920*200";
          }
          if (this.form.sliderType == 2) {
            //pc首页轮播图
            this.jumpTypeList = this.newTwo;
            this.form.jumpType = 0;
            this.imgSize = "1920*425";
          }
          if (res.data.content == "<p><br></p>") {
            this.form.content = "";
          }
          editor.txt.html(this.form.content);
          this.$refs.upload.setPicUrl(this.form.sliderImg);
        }
      });
    },
    dataChange(data1, data2) {
      this.form.liveTime = data1;
    },
    handelSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // 用户id数据
            let ids = [];
            this.selectUsers.forEach((e) => {
              ids.push(e.id);
            });
            this.form.lecturerId = ids;
            addSlider(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          } else if (this.type === 1) {
            // 编辑
            editSlider(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          }
        }
      });
    },
    handelCancel() {
      this.drawerVisible = false;
    },
    handleUpload(v) {
      this.form.sliderImg = v.fileUrl;
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>